import { html, when } from '@microsoft/fast-element';
import { ChameleonRebrandingObserver } from '../Observers';
import { SvgComponent } from '../Svg';
import { SVG_GOTO_BLACK_YELLOW, SVG_GOTO_WHITE_YELLOW } from '@getgo/chameleon-icons';
export const launchScreenComponentTemplate = (context, _definition) => {
    const svgTag = context.tagFor(SvgComponent);
    return html `
    <slot>
    
      <${svgTag} class="rebranding-logo-container">
        ${when((x) => x.isDarkMode() || x.isHighContrast(), html `${SVG_GOTO_WHITE_YELLOW}`)}
        ${when((x) => !x.isDarkMode() && !x.isHighContrast(), html `${SVG_GOTO_BLACK_YELLOW}`)}</${svgTag}>
    </slot>
    `;
};
export class LaunchScreenComponent extends ChameleonRebrandingObserver {
    constructor() {
        super(...arguments);
        this.baseName = 'launch-screen';
    }
    connectedCallback() {
        super.connectedCallback();
        this.observer.observe(this.getThemeProvider(), { attributes: true });
        this.updateVisibility();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
    }
    rebrandingObserverHandler() {
        this.updateVisibility();
    }
    updateVisibility() { }
    isDarkMode() {
        const themeProvider = this.getThemeProvider();
        const automaticAttr = themeProvider.getAttribute('automatic');
        const isAutomatic = automaticAttr === 'true' || automaticAttr === '';
        return isAutomatic
            ? window.matchMedia('(prefers-color-scheme: dark)').matches
            : themeProvider.getAttribute('theme') === 'dark';
    }
    isHighContrast() {
        const themeProvider = this.getThemeProvider();
        return themeProvider.getAttribute('theme') === 'high-contrast';
    }
}
